<template>
	<div
		v-infinite-scroll="
			() =>
				offset
					? onClick({
							offset: offset,
							userId:
								'userId' in (currentRetailer || {})
									? currentRetailer.userId
									: selfUserId
					  })
					: {}
		"
		:infinite-scroll-disabled="!loading"
		infinite-scroll-distance="100"
		infinite-scroll-throttle-delay="100"
		min-height="100vh"
	>
		<div v-for="item in items" :key="item.userId">
			<associate-card
				:associateData="item"
				:isFixed="false"
				@ON_CLICK="onClick(item)"
				@GO_BACK="goBack"
				:jeet11Color="jeet11Color"
				:rummyColor="rummyColor"
			/>
		</div>
	</div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import AssociateCard from "./AssociateCard.vue";

export default {
	name: "InfiniteScroll",
	props: [
		"items",
		"jeet11Color",
		"rummyColor",
		"offset",
		"currentRetailer",
		"loading",
		"selfUserId"
	],
	directives: { infiniteScroll },
	components: {
		"associate-card": AssociateCard
	},
	methods: {
		goBack() {
			this.$emit("GO_BACK");
		},
		onClick(item) {
			this.$emit("ON_CLICK", item);
		}
	}
};
</script>
